import React from 'react';
import { LibraryPage } from './LibraryPage';
import { inspectionLibrary } from '../../library/inspectionLibrary';

/** Superadmin page for the kontroll library. */
const InspectionLibraryPage: React.FC = () => <LibraryPage config={inspectionLibrary} />;

export default InspectionLibraryPage;
